import IconService, { HttpProvider } from 'icon-sdk-js/build/icon-sdk-js.web.min.js';

export const networkId = process.env.REACT_APP_ICON_NODE_NETWORK_ID
export const scoreAddress = process.env.REACT_APP_ICON_SCORE_ADDRESS
export const iconService = new IconService(new HttpProvider(process.env.REACT_APP_ICON_NODE_URL));